import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { GoogleReCaptchaProvider } from "@google-recaptcha/react";

function App() {
  const recaptchaSiteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY as string | undefined;

  return (
    <I18nextProvider i18n={i18n}>
      {recaptchaSiteKey ? (
        <GoogleReCaptchaProvider type="v3" siteKey={recaptchaSiteKey}>
          <BrowserRouter basename={__BASE_PATH__}>
            <AppRoutes />
          </BrowserRouter>
        </GoogleReCaptchaProvider>
      ) : (
        <BrowserRouter basename={__BASE_PATH__}>
          <AppRoutes />
        </BrowserRouter>
      )}
    </I18nextProvider>
  );
}

export default App;
